import React from "react";

var DatePicker = React.createClass({

  picker: null,
  
  _onChange: function(value) {
    if (!value.select) return;

    var date = moment(value.select);
    this.props.onChange(date);
  },

  openPicker: function() {
    var picker = this.picker.pickadate('picker'); // what?
    picker.open();
  },
  
  componentDidMount: function() {
    this.picker = $(this.refs.datepicker.getDOMNode()).pickadate({
      format: this.props.format,
      clear: '',
      close: '',
      today: '',
      onSet: this._onChange
    });
  },
  
  render: function() {
    var value = moment(this.props.value).format('MMM D, YYYY');
    
    return (
        <div className="rw-datetimepicker rw-widget">

        <input ref='datepicker' type='text' className='rw-input datepicker' defaultValue={value} onChange={this.props.onChange} />
        
        <span className="rw-select">
        <button onClick={this.openPicker} tabIndex="-1" aria-disabled="false" type="button" className="rw-btn-calendar rw-btn"><i className="fa fa-calendar"></i>
        </button>
        </span>

        </div>
    );
  }
});

module.exports = DatePicker;



// WEBPACK FOOTER //
// ./components/datepicker.js